import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionConfirmModel } from '../../../models/action-confirm.model';
import { SubfooterRequestList, SubfooterRequestUpdate } from '../../../models/api-store/subfooter/subfooter.request.model';
import { SubfooterService } from '../../../services/api-store/subfooter/subfooter.service';
import { ActionConfirmComponent } from '../../ui/actionconfirm/actionconfirm.component';
import { FloatingItem } from '../../ui/floatingbar/floatingbar-item';
import { SubfooterCreateComponent } from './subfooter-create/subfooter-create.component';
import { SubfooterEditComponent } from './subfooter-edit/subfooter-edit.component';
import { SpinnerService } from '../../../services/spinner/spinner.service';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../utils/config/modal-settings';
import { TRUE } from '../../../utils/config/const';

@Component({
  selector: 'app-subfooter',
  templateUrl: './subfooter.component.html',
  styleUrls: ['./subfooter.component.scss']
})
export class SubfooterComponent implements OnInit {


  numeroPagina: number = 0;
  dimPagina: number = 20;
  public entityList: any = [];

  /**
   * Configura i button della floatingbar
   */
  public menuItems: FloatingItem[] = [
    {
      title: '',
      icon: 'fas fa-upload',
      choice: 'CREATE'
    }
  ];

  constructor(
    private router: Router,
    private subfooterService: SubfooterService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {
    this.spinner.show();
    this.initTable();
  }

  private draggedIndex: number;
  public draggedOverIndex: number;
  public rowClickActive: boolean = false;
  onDragStart(index): void {
    this.draggedIndex = index;
  }
  onDrop($event, index): void {
    $event.preventDefault();
    const item = this.entityList[this.draggedIndex];
    this.entityList.splice(this.draggedIndex, 1);
    this.entityList.splice(index, 0, item);
    if (this.draggedIndex != index) {
      this.saveRangeSubfooter(this.entityList, this.draggedIndex, index);
    }
    this.draggedIndex = -1;
    this.draggedOverIndex = -1;
    this.rowClickActive = false;
  }
  allowDrop($event, index): void {
    this.draggedOverIndex = index;
    $event.preventDefault();
  }
  rowClickMouseDown($event) {
    this.rowClickActive = true;
  }
  rowClickMouseUp($event) {
    this.rowClickActive = false;
  }

  saveRangeSubfooter(subfooterList, start, end) {
    console.log(start + " : " + end);
    let startLoop = 0;
    let endLoop = 0;
    if (start > end) {
      startLoop = end;
      endLoop = start;
    } else if (start < end) {
      startLoop = start;
      endLoop = end;
    }

    for (let i = startLoop; i <= endLoop; i++) {
      this.updateIndexSubfooter(subfooterList[i], i);
    }
  }


  updateIndexSubfooter(obj, newIndex) {
    this.spinner.show();
    let request = new SubfooterRequestUpdate();
    request.province = obj.province;
    request.index = newIndex;
    this.subfooterService.update(obj.id, request).subscribe(
      (response) => {
        //Aggiorna riga
        this.setRowByID(response, obj.id);
        //Togli spinner
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.spinner.hide();
      }
    );
  }


  setRowByID(result, id) {
    //Aggiorna riga
    let trovato = false;
    for (let i = 0; i < this.entityList.length && !trovato; i++) {
      if (this.entityList[i].id === id) {
        this.entityList[i] = result;
        trovato = true;
      }
    }
  }


  /**
   * Inizializza la tabella
   */
  initTable() {
    let subfooterRequestSearch = this.getFilter();
    this.subfooterService.getList(subfooterRequestSearch).subscribe(
      (response) => {
        this.setListEntityList(response);
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.spinner.hide();
      }
    );
  }

  setListEntityList(response) {
    if (response != null && typeof response != typeof undefined) {
      if (response.hasOwnProperty("data")) {
        this.entityList = [];
        for (let data of response.data) {
          this.entityList.push(data);
        }
      }
    }
  }

  getFilter() {
    let promotionEventRequestSearch = new SubfooterRequestList();
    promotionEventRequestSearch.pageNumber = this.numeroPagina;
    promotionEventRequestSearch.pageSize = this.dimPagina;
    return promotionEventRequestSearch;
  }

  delete(id) {
    this.spinner.show();
    this.subfooterService.delete(id)
      .subscribe(
        (response: any) => {
          this.initTable()
          //Togli spinner
          this.spinner.hide();
          //Feedback all'utente
          this.toastr.success('Subfooter cancellato con successo', 'Cancella subfooter');
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.spinner.hide();
          this.toastr.error('Si è verificato un errore durante la cancellazione del subfooter', 'Cancella subfooter fallita', {
            timeOut: 5000
          });
        }
      );
  }

  clickButtonDelete(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.delete(id);
        }
      }
    });
  }

  clickButtonUpdate(id) {
    //Apre modale di modifica
    const modalRef = this.modalService.open(SubfooterEditComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.id = id;
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        //Aggiorna riga
        this.setRowByID(result, id);
        //Togli spinner
        this.spinner.hide();
      }
    });
  }

  choiceButtonResponse($event) {
    if ($event == "CREATE") {
      //Apre modale di create
      const modalRef = this.modalService.open(SubfooterCreateComponent, DIALOG_LARGE_CONFIG);
      let lastindex = this.entityList.length;
      if (lastindex > 0) {
        lastindex = this.entityList[lastindex - 1].index + 1;
      }
      modalRef.componentInstance.newIndex = lastindex;
      modalRef.result.then(result => {
        if (result && result != "CLOSE") {
          this.entityList.push(result);
          //Togli spinner
          this.spinner.hide();
        }
      });
    }
  }



}
